<template>
  <IonItemSliding>
    <IonItem lines="none" @click.stop.prevent="$emit('docClicked', doc, doc.url!)">
      <div class="my-2" slot="start">
        <img class="h-8 w-8" :src="iconSrc" alt="" />
      </div>
      <IonLabel>
        <div class="font-bold text-xs flex-nowrap overflow-hidden text-gray-700">{{ doc.createdBy }}</div>
        <div>{{ doc.title }}</div>
        <div v-if="doc.createdAt" class="text-xs font-medium flex-nowrap overflow-hidden text-gray-500">
          {{ formatTimeAgo(doc.createdAt) }}
        </div>
      </IonLabel>
    </IonItem>
    <IonItemOptions slot="end" v-if="doc.createdBy && doc.createdBy === auth.user?._id">
      <IonItemOption @click="$emit('deleteClicked')" color="danger">
        <i class="icon-trash-2"></i>
      </IonItemOption>
    </IonItemOptions>
  </IonItemSliding>
</template>

<script setup lang="ts">
import { useAuth } from '@/stores/auth.store';
import { IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel } from '@ionic/vue';
import { IDocument } from '@ncss/models';
import { formatTimeAgo } from '@vueuse/core';
import { computed } from 'vue';

const auth = useAuth();

defineEmits<{
  (e: 'deleteClicked'): void;
  (e: 'docClicked', doc: IDocument, url: string): void;
}>();

const props = defineProps<{
  doc: IDocument;
}>();

const iconSrc = computed(() => {
  if (/pdf/gi.test(props.doc.type)) {
    return 'files/file-pdf.svg';
  }
  if (/(excel)|(numbers)|(spreadsheet)/gi.test(props.doc.type)) {
    return 'files/file-xls.svg';
  }
  if (/(text\/csv)|(text\/comma-separated-values)/gi.test(props.doc.type)) {
    return 'files/file-csv.svg';
  }
  if (/text\/html/gi.test(props.doc.type)) {
    return 'files/file-html.svg';
  }
  if (/text\/plain/gi.test(props.doc.type)) {
    return 'files/file-txt.svg';
  }
  if (/word/gi.test(props.doc.type)) {
    return 'files/file-doc.svg';
  }
  if (/video/gi.test(props.doc.type)) {
    return 'files/file-mov.svg';
  }
  if (/s3db/gi.test(props.doc.type)) {
    return 'files/file-sdf.svg';
  }
  if (/log/gi.test(props.doc.type)) {
    return 'files/file-log.svg';
  }
  if (/presentation/gi.test(props.doc.type)) {
    return 'files/file-ppt.svg';
  }
  if (/zip/gi.test(props.doc.type)) {
    return 'files/file-zip.svg';
  }
  return 'files/file.svg';
});
</script>
